import { render, staticRenderFns } from "./accessoryMaterial.vue?vue&type=template&id=0e44895c&scoped=true"
import script from "./accessoryMaterial.vue?vue&type=script&lang=js"
export * from "./accessoryMaterial.vue?vue&type=script&lang=js"
import style0 from "./accessoryMaterial.vue?vue&type=style&index=0&id=0e44895c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e44895c",
  null
  
)

export default component.exports